import { render } from "./FileDropzoneComponent.vue?vue&type=template&id=7a2301c8&scoped=true"
import script from "./FileDropzoneComponent.vue?vue&type=script&lang=js"
export * from "./FileDropzoneComponent.vue?vue&type=script&lang=js"

import "./FileDropzoneComponent.vue?vue&type=style&index=0&id=7a2301c8&scoped=true&lang=css"

import exportComponent from "/Users/vincent/Herd/app.prixo.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a2301c8"]])

export default __exports__